<template>
  <v-container class="pa-0">
    <v-row
      :class="isEmbedded ? 'pa-0 align-content-center' : 'align-content-center'"
      class="mt-4 mb-3"
      no-gutters>
      <v-col
        :class="isEmbedded ? 'px-3' : 'px-7'"
        cols="12"
        xs="12"
        sm="8">
        <v-card
          flat
          color="transparent">
          <v-list-item
            two-line
            class="px-0">
            <v-list-item-avatar
              :size="isEmbedded ? '48' : '74'"
              class="my-0">
              <v-img :src="ownerPicture"/>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title
                :class="isEmbedded ? 'body-1 font-weight-bold black--text' : 'title font-weight-bold black--text'"
                class="divHostName"
              >{{ hostName }}</v-list-item-title>
              <v-list-item-subtitle
                :class="isEmbedded ? 'body-2 grey--text text--darken-3' : 'body-1 grey--text text--darken-3 font-weight-light'"
              >Meeting host</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col
        :class="isEmbedded ? 'px-5 align-content-center black--text mt-2' : 'align-content-center black--text px-7'"
        cols="12"
        xs="12"
        sm="4">
        <v-layout
          :row="!isEmbedded"
          justify-center
          align-center>
          <v-flex
            :class="isEmbedded ? 'body-2' : 'body-1 mb-2'"
            class="grey--text text--darken-3 font-weight-medium"
            xs12>
            <v-icon
              class="mr-4"
              size="32"
              color="grey">watch_later</v-icon>{{ duration }} {{ isEmbedded ? $t('home.minutesShort') : $t('home.minutes') }}
          </v-flex>
          <v-flex
            :class="isEmbedded ? 'body-2' : 'body-1 mb-2'"
            class="grey--text text--darken-3 font-weight-medium"
            xs12>
            <v-avatar
              :class="isEmbedded ? 'mr-3' : 'mr-4'"
              size="32px"
              class="my-0 ml-0">
              <v-img
                v-if="location === this.$t('home.googleMeet')"
                height="32px"
                width="32px"
                src="/assets/meet.png"/>
              <v-img
                v-else-if="location === this.$t('home.zoom') || locationZoomLink"
                height="32px"
                width="32px"
                src="/assets/zoom-logo.png"/>
              <v-icon
                v-else
                size="32"
                color="secondary">location_on</v-icon>
            </v-avatar>
            <span>{{ locationZoomLink ? this.$t('home.zoom') : location }}</span>
          </v-flex>
        </v-layout>

      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { localeMixin } from '../mixins'

export default {
  mixins: [localeMixin],
  props: {
    location: {
      type: String,
      required: true
    },
    duration: {
      type: Number,
      required: true
    },
    hostPicture: {
      type: String,
      default: null
    },
    hostName: {
      type: String,
      required: true
    },
    isEmbedded: {
      type: String,
      default: null
    }
  },

  data () {
    return {

    }
  },
  computed: {
    ownerPicture () {
      if (this.hostPicture && this.hostPicture.indexOf('/gmelius.io/assets/logo/color_100.png') < 0) {
        return this.hostPicture
      } else {
        return this.generateFromLetters(this.hostName, 100)
      }
    },
    locationZoomLink () {
      return this.location && this.location.startsWith('https://zoom.us/')
    }
  },
  mounted () {

  },
  methods: {
    generateFromLetters (firstName, size) {
      let name = firstName
      const string = name ? name.charAt(0).toUpperCase() : '?'
      const color = this.stringToColour(name)
      let canvas = null
      canvas = document.createElement('canvas')
      let context = canvas.getContext('2d')
      // Set canvas with & height
      canvas.width = size
      canvas.height = size
      // Select a font family to support different language characters
      // like Arial
      context.font = Math.round(canvas.width / 2) + 'px Arial'
      context.textAlign = 'center'
      context.fillStyle = color
      context.fillRect(0, 0, canvas.width, canvas.height)
      context.fillStyle = '#FFFFFF'
      context.fillText(string, size / 2, size / 1.5)
      // Set image representation in default format (png)
      return canvas.toDataURL()
    },
    stringToColour (string) {
      const hash = this.djb2(string)
      const r = (hash & 0xff0000) >> 16
      const g = (hash & 0x00ff00) >> 8
      const b = hash & 0x0000ff
      return (
        '#' +
        ('0' + r.toString(16)).substr(-2) +
        ('0' + g.toString(16)).substr(-2) +
        ('0' + b.toString(16)).substr(-2)
      )
    },
    /*
    * Computes a hash
    */
    djb2 (str) {
      let hash = 5381
      for (let i = 0; i < str.length; i++) {
        hash = (hash << 5) + hash + str.charCodeAt(i)
      }
      return hash
    }
  }
}
</script>
<style scoped>
  .divHostName {
    white-space: pre-wrap;
  }
</style>
